import React, { memo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,
} from "react-share";
import { FaInstagram } from 'react-icons/fa';
import save from '../../../../public/assets/images/pdp/save.svg';
import saved from '../../../../public/assets/images/pdp/saved.svg';
import shareImg from '../../../../public/assets/images/pdp/share.png';
import print from '../../../../public/assets/images/pdp/print.png';
import { setIsAddedToSaved, showSavedTooltip } from '@/redux/savedpreference/savedPreferenceSlice';
import { onSavePress, onUnsavePress } from '@/api/srpFilter';
import { updateSaveProperty } from '@/redux/PDP/pdpSlice';
import { getPDPPrint } from '@/api/PDP';
import PDPSaveModal from './PDPSaveModal';
import { setPropertyToSaveFrom } from '@/redux/login/loginSlice';
import { trackApiCall, trackButtonClick } from '@/utils/analytics';

const PDPHeaderActions = ({isForeclosure}) => {
  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const userEmailId = useSelector((state) => state.user?.user?.userEmailId);
  const {propertyToSaveFrom, isUserSubscribed} = useSelector((state) => state.login);
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const address = pdpInitData?.propertyDetails?.address;
  const emailBody = `Hi,

  I found this property you might be interested in on Hubzu.com`;

  useEffect(() => {
    if (propertyToSaveFrom === 'PDP' && (userEmailId || isUserSubscribed)) {
      onSave();
      dispatch(setPropertyToSaveFrom(null));
    }
  }, [propertyToSaveFrom, isUserSubscribed, userEmailId]);

  const onSave = async () => {
    const propertyId = pdpInitData?.propertyDetails?.propertyId;
    if (userEmailId || isUserSubscribed) {
      if (pdpInitData?.propertySpecialDetails?.onWatchList === "Y") {
        dispatch(updateSaveProperty("N"));

        trackButtonClick({
          eventName: "favourite_property_unsave_click",
          eventCategory: "NEW-PDP",
          eventSource: "pdp_header",
          eventLabel: `Property Id: ${
            pdpInitData?.propertyDetails?.propertyId
          }|propertyStatus: ${
            pdpInitData?.propertyDetails?.commonAttributes?.status || "N/A"
          }`,
        });

        const response = await onUnsavePress({ propertyId });
        if (response === "success") {
          dispatch(setIsAddedToSaved());

          trackApiCall({
            eventName: "favourite_property_unsaved",
            eventCategory: "NEW-PDP",
            eventSource: "pdp_header",
            eventLabel: `Property Id: ${propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: "favourite_property_unsave_error",
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${propertyId}`,
          });
        }
      } else {
        dispatch(updateSaveProperty("Y"));

        trackButtonClick({
          eventName: "favourite_property_save_click",
          eventCategory: "NEW-PDP",
          eventSource: "pdp_header",
          eventLabel: `Property Id: ${
            pdpInitData?.propertyDetails?.propertyId
          }propertyStatus: ${
            pdpInitData?.propertyDetails?.commonAttributes?.status || "N/A"
          }`,
        });

        const response = await onSavePress({ propertyId });
        if (response === "success") {
          dispatch(showSavedTooltip(true));
          dispatch(setIsAddedToSaved());

          trackApiCall({
            eventName: "favourite_property_saved",
            eventCategory: "NEW-PDP",
            eventSource: "pdp_header",
            eventLabel: `Property Id: ${propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: "favourite_property_save_error",
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${propertyId}`,
          });
        }
      }
    } else {
      setShowModal(true);
    }
  };

  const onClickPrint = async () => {
    await getPDPPrint({propertyId: pdpInitData?.propertyDetails?.propertyId});
     trackButtonClick({
      eventName: "print_click",
      eventCategory: "NEW-PDP",
      eventSource: "Print Click",
      eventLabel: `${pdpInitData?.propertyDetails?.propertyId}|${
        pdpInitData?.propertyDetails?.listingId
      }|${pdpInitData?.propertyDetails?.address?.streetNumber} ${
        pdpInitData?.propertyDetails?.address?.streetName
      }, ${pdpInitData?.propertyDetails?.address?.county}, ${
        pdpInitData?.propertyDetails?.address?.state
      }, ${pdpInitData?.propertyDetails?.address?.city}, ${
        pdpInitData?.propertyDetails?.address?.zip
      }|Referrer: Other|Foreclosure Property: ${
        isForeclosure ? "Yes" : "No"
      }|Status: ${
        pdpInitData?.propertyDetails?.commonAttributes?.status || "N/A"
      }`,
    });
  };

  const handleShareClick = () => {
    setIsOpen(!isOpen)
    trackButtonClick({
      eventName: "share_click",
      eventCategory: "NEW-PDP",
      eventSource: "Share Click",
      eventLabel: `${pdpInitData?.propertyDetails?.propertyId}|${
        pdpInitData?.propertyDetails?.listingId
      }|${pdpInitData?.propertyDetails?.address?.streetNumber} ${
        pdpInitData?.propertyDetails?.address?.streetName
      }, ${pdpInitData?.propertyDetails?.address?.county}, ${
        pdpInitData?.propertyDetails?.address?.state
      }, ${pdpInitData?.propertyDetails?.address?.city}, ${
        pdpInitData?.propertyDetails?.address?.zip
      }|Referrer: Other|Foreclosure Property: ${
        isForeclosure ? "Yes" : "No"
      }|Status: ${
        pdpInitData?.propertyDetails?.commonAttributes?.status || "N/A"
      }`,
    });
  }

  return (
    <div className="pdp-header-right-stick">
      <div className="single_property_social_share position-static transform-none mt30">
        <div className="spss style2 mt20 text-end tal-400">
          <button className="headerButton dropdown" id="pdpSaveBtn" onClick={onSave}>
            <img src={pdpInitData?.propertySpecialDetails?.onWatchList === "Y" ? saved : save} className="nav-tab-img" alt="" aria-hidden="true" />
            <span>{" "}Save</span>
          </button>
          <button className="headerButton dropdown" id="dropdownMenu2" onClick={() => handleShareClick()}>
            <img src={shareImg} className="nav-tab-img" alt="" aria-hidden="true" />
            {" "}Share
            <div className={`dropdown-menu shareDropDown ${isOpen ? 'show' : ''}`} aria-labelledby="dropdownMenu2">
              <div>
                <EmailShareButton
                  body={emailBody}
                  subject={`Hubzu.com ${address?.streetNumber} ${address?.streetName} ${address?.city} ${address?.state} ${address?.zip}`}
                  url={window.location.href}
                  aria-label='Email'
                >
                  <EmailIcon size={32} round={true}></EmailIcon>
                </EmailShareButton>
              </div>
              <div>
                <FacebookShareButton url={window.location.href} aria-label='Facebook'>
                  <FacebookIcon size={32} round={true} />
                </FacebookShareButton>
              </div>
              <div
                aria-label='Instagram'
                onClick={() => {
                  window.open('https://www.instagram.com/hubzu_official', '_blank', 'left=20,top=20,width=600,height=500,toolbar=1,resizable=0');
                }}
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', borderRadius: '50%', background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)' }}
              >
                <FaInstagram size={18} color='white' />
              </div>
              <div>
                <LinkedinShareButton url={window.location.href} aria-label='LinkedIn'>
                  <LinkedinIcon size={32} round={true}></LinkedinIcon>
                </LinkedinShareButton>
              </div>
              <div
                aria-label='Pinterest'
                onClick={() => {
                  window.open(`//www.pinterest.com/pinthis/?url=${window.location.href}`, 'mywin','left=20,top=20,width=600,height=500,toolbar=1,resizable=0');
                }}>
                <PinterestIcon size={32} round={true}></PinterestIcon>
              </div>
            </div>
          </button>
          <button className="headerButton" onClick={onClickPrint}>
            <img src={print} className="nav-tab-img" alt="" aria-hidden="true" />
            {" "} Print</button>
          {showModal && <PDPSaveModal showModal={showModal} setShowModal={setShowModal}/>}
        </div>
      </div>
    </div>
  );
};
export default memo(PDPHeaderActions);